import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '../assets/page-image/hpkf/banner.png';
import _imports_1 from '../assets/ercode.jpg';
const _hoisted_1 = {
  class: "hpkf-wrapper"
};
const _hoisted_2 = {
  class: "hpkf-page"
};
const _hoisted_3 = {
  class: "section jinpin-section"
};
const _hoisted_4 = {
  class: "jinpin-content"
};
const _hoisted_5 = {
  class: "jinpin-text"
};
const _hoisted_6 = {
  class: "jinpin-image"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "section chanpin-section"
};
const _hoisted_9 = {
  class: "chanpin-scroll-container"
};
const _hoisted_10 = {
  class: "chanpin-scroll-content"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "section huanjing-section"
};
const _hoisted_13 = {
  key: 0,
  class: "huanjing-content"
};
const _hoisted_14 = {
  class: "huanjing-left"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "huanjing-right"
};
const _hoisted_17 = {
  class: "huanjing-right-item"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "huanjing-right-item"
};
const _hoisted_20 = ["src"];
import { ref, onMounted } from 'vue';
import Footer from '@/components/Footer.vue';
import { getLakesideCoffeeInfo } from '@/api/lakeside';
// 湖畔咖啡信息数据
export default /*@__PURE__*/_defineComponent({
  __name: 'Hpkf',
  setup(__props) {
    const coffeeInfo = ref({});
    // 获取湖畔咖啡信息
    const fetchCoffeeInfo = async () => {
      try {
        const res = await getLakesideCoffeeInfo();
        if (res.code === 200) {
          coffeeInfo.value = res.data;
          // console.log('湖畔咖啡信息:', coffeeInfo.value);
        }
      } catch (error) {
        console.error('获取湖畔咖啡信息失败:', error);
      }
    };
    // 页面加载时获取数据
    onMounted(() => {
      fetchCoffeeInfo();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "banner-section"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "湖畔咖啡"
      })], -1)), _createElementVNode("div", _hoisted_3, [_cache[0] || (_cache[0] = _createStaticVNode("<div class=\"section-header\" data-v-3acc29be><div class=\"title-wrapper\" data-v-3acc29be><div class=\"title-box\" data-v-3acc29be>金品咖啡</div><div class=\"title-underline\" data-v-3acc29be></div></div><div class=\"title-line\" data-v-3acc29be></div><span class=\"more-btn\" data-v-3acc29be></span></div>", 1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", null, _toDisplayString(coffeeInfo.value.descInfo?.description || '精选阿拉比卡咖啡豆，中深烘焙，既保留了豆子的纯度和又不失醇厚豆香味道，自有的风味。'), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: coffeeInfo.value.descInfo?.coveImage || require('../assets/page-image/hpkf/jingpin.png'),
        alt: "金品咖啡"
      }, null, 8, _hoisted_7)])])]), _createElementVNode("div", _hoisted_8, [_cache[1] || (_cache[1] = _createStaticVNode("<div class=\"section-header\" data-v-3acc29be><div class=\"title-wrapper\" data-v-3acc29be><div class=\"title-box\" data-v-3acc29be>产品上新</div><div class=\"title-underline\" data-v-3acc29be></div></div><div class=\"title-line\" data-v-3acc29be></div><span class=\"more-btn\" data-v-3acc29be></span></div>", 1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coffeeInfo.value.newProduct, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "chanpin-item"
        }, [_createElementVNode("img", {
          src: item.url,
          alt: "产品"
        }, null, 8, _hoisted_11)]);
      }), 128))])])]), _createElementVNode("div", _hoisted_12, [_cache[2] || (_cache[2] = _createStaticVNode("<div class=\"section-header\" data-v-3acc29be><div class=\"title-wrapper\" data-v-3acc29be><div class=\"title-box\" data-v-3acc29be>环境展示</div><div class=\"title-underline\" data-v-3acc29be></div></div><div class=\"title-line\" data-v-3acc29be></div><span class=\"more-btn\" data-v-3acc29be></span></div>", 1)), coffeeInfo.value.environment && coffeeInfo.value.environment.length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
        src: coffeeInfo.value.environment[0].url,
        alt: "环境展示"
      }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
        src: coffeeInfo.value.environment[1].url,
        alt: "环境展示"
      }, null, 8, _hoisted_18)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
        src: coffeeInfo.value.environment[2].url,
        alt: "环境展示"
      }, null, 8, _hoisted_20)])])])) : _createCommentVNode("", true)]), _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"section huanjing-section\" data-v-3acc29be><div class=\"section-header\" data-v-3acc29be><div class=\"title-wrapper\" data-v-3acc29be><div class=\"title-box\" data-v-3acc29be>联系我们</div><div class=\"title-underline\" data-v-3acc29be></div></div><div class=\"title-line\" data-v-3acc29be></div><span class=\"more-btn\" data-v-3acc29be></span></div><div class=\"contact-content\" data-v-3acc29be><div class=\"contact-left\" data-v-3acc29be><img src=\"" + _imports_1 + "\" alt=\"二维码\" data-v-3acc29be></div><div class=\"contact-right\" data-v-3acc29be><div class=\"contact-item\" data-v-3acc29be>扫码点餐</div><div class=\"contact-item\" data-v-3acc29be>联系方式：***********</div></div></div></div>", 1))]), _createVNode(Footer)]);
    };
  }
});